import { PropostaFinanceira } from "@/models/consignado/propostaFinanceira.model";
import { axiosConsignadoInstance } from "../axiosInstance";
import { RelatorioConciliacao } from "@/models/consignado/relatorioConciliacao.model";

export interface ExecutarConciliacaoEmMassaDto {
  propostaFinanceiraIds: string[];
}

export interface ExecutarConciliacaoEmMassaSucesso {
  propostaFinanceiraId: string;
  quantidadeRelatorios: number;
}

export interface ExecutarConciliacaoEmMassaFalha {
  propostaFinanceiraId: string;
  erro: string;
}

export interface ExecutarConciliacaoEmMassaResponse {
  totalRecebido: number;
  totalProcessado: number;
  sucesso: ExecutarConciliacaoEmMassaSucesso[];
  falhas: ExecutarConciliacaoEmMassaFalha[];
}

export interface HistoricoModificacaoItem {
  campo: string;
  valorAnterior: unknown;
  valorNovo: unknown;
}

export interface HistoricoModificacaoContrato {
  usuario: string;
  camposModificados: string[];
  oQueModificou: HistoricoModificacaoItem[];
}

export const getPropostasFinanceiras = async (page: number, limit: number, filters: any) => {
  try {
    const params = {
      page,
      limit,
      ...filters
    };
    
    const { data } = await axiosConsignadoInstance.get('/api-consignado-trabalhador/v1/conciliacao', {
      params,
      paramsSerializer: {
        indexes: null,
      },
    });
    return data; 
  } catch (error: any) {
    console.error(error)
    throw error;
  }
};

export const getPropostasFinanceirasListView = async (
  page: number,
  limit: number,
  filters: any
) => {
  try {
    const params = {
      page,
      limit,
      ...filters
    };

    const { data } = await axiosConsignadoInstance.get(
      '/api-consignado-trabalhador/v1/conciliacao/listview',
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );

    return data;
  } catch (error: any) {
    console.error(error)
    throw error;
  }
};

export const getPropostaFinanceira = async (idPropostaFinanceira: string): Promise<PropostaFinanceira> => {  
  try {
    const { data } = await axiosConsignadoInstance.get(`/api-consignado-trabalhador/v1/conciliacao/${idPropostaFinanceira}`);
    return data; 
  } catch (error: any) {
    console.error(error)
    throw error;
  }
};

export const getRelatoriosPorProposta = async (propostaId: string): Promise<RelatorioConciliacao[]> => {
  try {
    const response = await axiosConsignadoInstance.get(`/api-consignado-trabalhador/v1/conciliacao/relatorio/proposta-financeira/${propostaId}`);
    return response.data;
  } catch (error: any) {
    console.error(error)
    throw error;
  }
};

export const editarPropostaFinanceira = async (
  idPropostaFinanceira: string,
  payload: Partial<PropostaFinanceira>
): Promise<PropostaFinanceira> => {
  try {
    const { data } = await axiosConsignadoInstance.patch(
      `/api-consignado-trabalhador/v1/conciliacao/proposta-financeira/${idPropostaFinanceira}`,
      payload
    );

    return data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const conciliarPropostaFinanceira = async (propostaFinanceiraId: string) => {
  try {
    const response = await axiosConsignadoInstance.post(`/api-consignado-trabalhador/v1/conciliacao/executar/${propostaFinanceiraId}`);
    return response.data;
  } catch (error: any) {
    console.error(error)
    throw error;
  }
}

export const executarConciliacaoEmMassa = async (
  payload: ExecutarConciliacaoEmMassaDto
): Promise<ExecutarConciliacaoEmMassaResponse> => {
  try {
    const { data } = await axiosConsignadoInstance.post(
      "/api-consignado-trabalhador/v1/conciliacao/executar/massa",
      payload
    );

    return data as ExecutarConciliacaoEmMassaResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUsuariosModificadoresPropostaFinanceira = async (
  propostaFinanceiraId: string
): Promise<HistoricoModificacaoContrato[]> => {
  try {
    const { data } = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/conciliacao/proposta-financeira/${propostaFinanceiraId}/usuarios-modificadores`
    );

    return Array.isArray(data) ? (data as HistoricoModificacaoContrato[]) : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};